import 'dayjs/locale/en'
import 'dayjs/locale/fr'
import 'dayjs/locale/de'
import 'dayjs/locale/it'
import 'dayjs/locale/uk'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import ordersEN from './locales/orders.en.json'
import ordersFR from './locales/orders.fr.json'
import ordersUK from './locales/orders.uk.json'
import { Locale } from 'antd/es/locale'
import frFR from 'antd/locale/fr_FR'
import enGB from 'antd/locale/en_GB'
import ukUA from 'antd/locale/uk_UA'

export type LocaleType = 'fr' | 'uk' | 'en'

/**
 * Get the locale ant object from the locale string
 * @param locale i18n locale string
 * @returns Locale ant object
 */
export const antLocale: { [key in LocaleType]: Locale } = {
  en: enGB,
  fr: frFR,
  uk: ukUA,
}

export const resources = {
  en: {
    orders: ordersEN,
  },
  fr: {
    orders: ordersFR,
  },
  uk: {
    orders: ordersUK,
  },
} // as const

i18n.use(initReactI18next).init(
  {
    lng: localStorage.getItem('settingsLng') || process.env.REACT_APP_DEFAULT_LOCALE,
    fallbackLng: 'en',
    resources,
    nsSeparator: false,
  },
  () => {},
)

i18n.on('languageChanged', (lng) => {
  localStorage.setItem('settingsLng', lng)
})

export default i18n
